import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-data-disclaimer',
    template: `
        <div class="data-disclaimer">
            <div class="content-column">
                <ng-container *ngFor="let disclaimer of disclaimers">
                    <egov-text-ui-placeholder *ngIf="!disclaimer" length="360" lengthThreshold="40"></egov-text-ui-placeholder>
                    <div *ngIf="disclaimer" class="disclaimer" [innerHTML]="disclaimer"></div>
                </ng-container>
            </div>
        </div>
    `,
    styleUrls: ['./data-disclaimer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataDisclaimerComponent
{
    // Customization

    @Input() protected disclaimers?: string[];
}
